import { takeLatest, call, put, delay } from "redux-saga/effects"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import { GET_ANALYTICS_REQUEST } from "../types"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import axiosClient from "axios"
import { getAnalyticsRequestFailed, getAnalyticsRequestReset, getAnalyticsRequestSuccess } from "../actions/dashboardActions"
import { getAnalyticsService } from "../services/dashboardServices"

function* getAnalyticsSaga(action) {
	try {
		const result = yield call(getAnalyticsService)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getAnalyticsRequestSuccess(result?.data?.analytics))
		} else {
			yield put(getAnalyticsRequestFailed(result?.data?.message))
		}
	} catch (error) {
		if (error?.response?.status === 403) {
			clearLocalStorage()
			yield put(clearMultibase())
			yield put(logoutUser())
			return
		}
		yield put(getAnalyticsRequestFailed(Messages.SERVER_ERROR))
		yield put(getAnalyticsRequestReset())
	}
}

export default function* dashboardSaga() {
	yield takeLatest(GET_ANALYTICS_REQUEST, getAnalyticsSaga)
}
